<template>
  <div class="tool" @click="handleClose">
    <div class="panel" @click.prevent>
      <div class="close" @click="handleClose"></div>
      <h3>Creativity</h3>
      <div class="text">
        <span>Ordinary</span>
        <span>Witty</span>
        <span class="member">Creativity</span>
      </div>
      <input type="range" v-model="creativityNum" min = "0" max = "100" step="50" :style="{background:'linear-gradient(to right, #3adcbc, #3adcbc ' + creativityNum + '%, #e0e0e0 ' + creativityNum + '%, #e0e0e0)'}" />
      <h3>Memory</h3>
      <div class="text">
        <span>Ordinary</span>
        <span class="member">High</span>
        <span class="member">Super</span>
      </div>
      <input type="range" v-model="memoryNum" min = "0" max = "100" step="50" :style="{background:'linear-gradient(to right, #3adcbc, #3adcbc ' + memoryNum + '%, #e0e0e0 ' + memoryNum + '%, #e0e0e0)'}" />
      <div class="btn" @click="handleSave">Save</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { debounce, getItem, setItem } from '@/utils';

const SETTING_KEY = 'comics_v1_set';
export default {
  data() {
    return {
      creativityNum: Number(getItem(SETTING_KEY)?.creativityNum) || 0,
      memoryNum: Number(getItem(SETTING_KEY)?.memoryNum) || 0,
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
  },
  methods: {
    handleSave() {
      const { is_vip } = this.userInfo;
      const { creativityNum = 0, memoryNum = 0 } = this;
      if (!is_vip && (creativityNum > 50 || memoryNum > 0)) {
        this.goPremium();
        return;
      }
      setItem(SETTING_KEY, { creativityNum, memoryNum });
    },
    handleClose() {
      this.$emit('close');
    },
    goPremium: debounce(function goTopUp() {
      this.$toast.error('Vip Only, join Premium to use...');
      const t = setTimeout(() => {
        clearTimeout(t);
        this.$router.push('/premium');
      }, 500);
    }, 800, true),
  },
};
</script>
<style lang="less" scoped>
.tool {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .panel {
    position: relative;
    background: #fff;
    padding: 28px 16px 42px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    h3 {
      font-size: @fontLarge;
      font-weight: 600;
      line-height: 23px;
    }
    .text {
      font-size: 15px;
      font-weight: 500;
      color: rgba(117, 117, 117, 1);
      display: flex;
      justify-content: space-between;
      padding: 16px 0;
      span {
        flex: 1;
        display: flex;
        &:nth-child(2) {
          justify-content: center;
        }
        &:nth-child(3) {
          justify-content: flex-end;
        }
      }
      .member {
        &::before {
          content: "";
          background: url(~@/assets/images/icon/crown.png) left center no-repeat;
          background-size: 18px 18px;
          padding-left: 24px;
        }
      }
    }
    input[type="range"] {
      background: #e0e0e0;
      height: 6px;
      border-radius: 8px;
      display: block;
      width: 286px;
      margin: 0 auto 33px;
      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        border: 1px solid transparent;
        box-shadow: 0px 0px 8.1px 0px rgba(0, 0, 0, 0.4);
      }
    }
  }
  .btn {
      background: linear-gradient(130.84deg, #3BDC7E 18.93%, #0DCFA9 79.21%);
    height: 54px;
    line-height: 54px;
    border-radius: 33px;
    text-align: center;
    font-size: @fontLarge;
    font-weight: 600;
    margin-top: 36px;
  }
  .close {
    width: 12px;
    height: 12px;
    background: url('@/assets/images/icon/close-black.png') center no-repeat;
    background-size: 100%;
    position: absolute;
    top: 28px;
    right: 16px;
  }
}
</style>
